<template>

<div class="aid" :class="{'is-focus': is.focus}">

	<component v-if="currentSection" v-bind:is="currentSection.type" v-on:next="onNext" v-on:back="onBack" :section="currentSection" v-on:introducing="is.focus = true" v-on:introduced="is.focus = false"></component>

</div>

</template>

<script>

import components from './aid'

export default {

	components,

	data: function() {

		return {
			is: {
				focus: false
			}
		}

	},

	computed: {

		currentSection: function() {

			return this.$_.findWhere(this.$store.getters['data/aid/sections/all'], {
				id: this.$store.getters['session/section/current']
			})

		},

		isChildSection: function() {

			return this.currentSection && this.currentSection.patient && this.currentSection.patient.parent > 0

		}

	},

	methods: {

		onBack: function() {

			if (this.isChildSection) {

				this.$store.commit('session/section/current', this.currentSection.patient.parent)
				return

			}

			var sections = this.$store.getters['data/aid/sections/navigable']

			var index = this.$_.findIndex(sections, function(section) {

				return section.id === this.$store.getters['session/section/current']

			}.bind(this))

			if (index === 0) {

				if (this.$isPatient) {

					this.$router.push({ name: 'Home' })

				} else {

					this.$store.commit('session/aid', false)
					this.$store.commit('session/section/current', true)
					this.$store.commit('session/finished', true)
					this.$store.commit('session/section/dynamic', {
						id: true,
						icon: 5,
						text: {
							title: 'Recommendation'
						}
					})

				}

			} else {

				this.$store.dispatch('back', sections[index - 1].id)

			}

		},

		onNext: function() {

			if (this.isChildSection) {

				var children = this.$store.getters['data/aid/sections/children'](this.currentSection.patient.parent)
				var childIndex = this.$_.findIndex(children, { id: this.currentSection.id })

				if (childIndex < children.length - 1) {

					this.$store.commit('session/section/current', children[childIndex + 1].id)

				} else {

					this.$store.commit('session/section/current', this.currentSection.patient.parent)

				}

				return

			}

			var sections = this.$store.getters['data/aid/sections/navigable']

			var index = this.$_.findIndex(sections, {
				id: this.$store.getters['session/section/current']
			})

			if (index < sections.length - 1) {

				this.$store.commit('session/section/current', sections[index + 1].id)

			}

		}

	}

}

</script>

<style>

.aid {
	position: absolute;
	left: 0px;
	top: 0px;
	width: 100%;
	height: 100%;
	overflow: hidden;
	transition: all 300ms ease-in-out;
}

.aid.is-focus {
	filter: blur(5px);
}

.subsection-close {
	width: 42px;
	height: 42px;
	border-radius: 21px;
	background-color: var(--aid-color);
	background-image: url(~@/assets/aid/improve/icon.close.svg);
	background-repeat: no-repeat;
	background-position: 50% 50%;
	cursor: pointer;
	position: absolute;
	right: 0;
	top: 0;
}

.subsection-close:hover {
	filter: brightness(90%);
}

</style>
